import * as React from 'react';

import {
  createStyles,
  Grid,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core';
import { default as ContainerDimensions } from 'react-container-dimensions';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%'
    },
    image: {
      width: '100%',
      borderRadius: theme.shape.borderRadius
    }
  });

type IProps = WithStyles<typeof styles> & {
  centLat: number;
  centLon: number;
};

const StreetViewImage: React.FC<IProps> = ({ classes, centLat, centLon }) => {
  return (
    <Grid item xs={12}>
      <div className={classes.root}>
        <ContainerDimensions>
          {({ width }) => (
            <img
              className={classes.image}
              src={`https://maps.googleapis.com/maps/api/streetview?size=${Number(
                width
              ).toFixed(
                0
              )}x${200}&radius=200&fov=120&source=outdoor&location=${centLat},${centLon}&key=${
                process.env.GOOGLE_MAPS_PUBLIC_API_KEY
              }`}
            />
          )}
        </ContainerDimensions>
      </div>
    </Grid>
  );
};

export default withStyles(styles)(StreetViewImage);
